import React, { CSSProperties, useEffect, useState } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { SelectValue } from 'antd/es/select'
import { Option, Select } from 'components/Select'

interface BooleanFilterProps {
  placeholder?: string
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  style?: CSSProperties
}

export const BooleanFilter: React.FC<BooleanFilterProps> = ({
  placeholder,
  filter,
  onFilterChange,
  ...props
}) => {
  const [selectedData, setSelectedData] = useState<SelectValue>([])
  const selectValue = filter.value ?? selectedData

  useEffect(() => {
    setSelectedData([])
  }, [filter.field])

  return (
    <Select
      style={{ width: 250 }}
      {...props}
      placeholder={placeholder}
      value={selectValue}
      onChange={(value: SelectValue) => {
        const dataValue = value || []
        setSelectedData(dataValue)
        onFilterChange({
          nextFilter: { ...filter, value: dataValue },
        })
      }}
      allowClear
      showSearch
    >
      <Option value='true'>true</Option>
      <Option value='false'>false</Option>
    </Select>
  )
}
